import type { AccessPolicies } from 'lib/acl/index.js';
import { policiesRetrieve } from '../openapi/operations/policiesRetrieve';

export const getUserPolicies = async () => {
  const result = await policiesRetrieve({ query: { targets: 'frontend' } as any });
  return result.data as any as AccessPolicies;
};

export function evaluateCondition(condition: string, context: Record<string, any> = {}) {
  if (!context || typeof context !== 'object') {
    console.error(
      `Cannot evaluate condition "${condition}": Invalid context ${JSON.stringify(context)}`,
    );
    return false;
  }

  // general example: `'field_name__in:val1|val2|val3'`
  // specific example: `'state__in:INPROGRESS|REJECTED'`
  const matchIn = condition
    .replace(/{([^}|]+)}/g, (_, name: string) => context[name])
    .match(/^([^:]+)__in:(.*)$/);
  if (matchIn) {
    const [, field, values] = matchIn;
    const expected = values.split('|');
    return expected.includes('' + context[field]);
  }

  console.error(`Cannot evaluate condition "${condition}".`);

  return false;
}
